module.exports = "/cyber/_next/static/images/vesenniiBannerItogiMobile-293ae02c28b72facd3d2a05da64794e7.jpg";